(function () {
  const countdownKey = 'shopify_cart_drawer_countdown_endtime';

  function setNewEndTime() {
    const newTime = new Date().getTime() + 5 * 60 * 1000;
    sessionStorage.setItem(countdownKey, newTime);
    return newTime;
  }

  function insertCountdown() {
    if (document.getElementById('drawer-countdown')) return;

    const drawer = document.querySelector('[id^="CartDrawer"]') || document.querySelector('[data-drawer]');
    if (!drawer || !drawer.offsetParent) return;

    const countdownEl = document.createElement('div');
    countdownEl.id = 'drawer-countdown';
    countdownEl.style = `
      background-color: #b30000;
      color: #ffffff;
      text-align: center;
      padding: 1em;
      margin: 1em auto;
      font-size: clamp(1rem, 4vw, 1.5rem); /* 自适应字体大小 */
      font-weight: 800;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      border-radius: 12px;
      box-sizing: border-box;
      max-width: 90%;
      width: 100%;
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.25);
      text-shadow: 1px 1px 3px rgba(0,0,0,0.5);
      line-height: 1.6;
    `;
    countdownEl.innerHTML = `⏰ Just 5 Left – Final <span id="drawer-timer">05:00</span>!`;

    const container = drawer.querySelector('[data-cart-drawer-items]') || drawer.querySelector('form');
    if (container) {
      container.prepend(countdownEl);
    }

    let endTime = sessionStorage.getItem(countdownKey);
    if (!endTime) {
      endTime = setNewEndTime();
    } else {
      endTime = parseInt(endTime);
    }

    function updateCountdown() {
      const now = new Date().getTime();
      let distance = endTime - now;

      if (distance <= 0) {
        endTime = setNewEndTime();
        distance = endTime - now;
      }

      const minutes = Math.floor(distance / 1000 / 60);
      const seconds = Math.floor((distance % (60 * 1000)) / 1000);
      const timer = document.getElementById("drawer-timer");
      if (timer) {
        timer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  setInterval(() => {
    const drawer = document.querySelector('[id^="CartDrawer"]') || document.querySelector('[data-drawer]');
    if (drawer && drawer.offsetParent !== null) {
      insertCountdown();
    }
  }, 1000);
})();
